import {
  ARBleAzoteFrequency,
  ARBleAzotePeriod,
  ARBleAzoteProductType,
  ARBleCIDestructionPeriod,
  ARBleCIDevelopment,
  ARBleCIType,
  ARBleEtatVegetatifSh,
  ARBlePastResiduType,
  ARBlePrairieAge,
  ARBlePrairieDestructionPeriod,
  ARBlePrairieExploitationMode,
  ARBlePrairiePostDestructionRank,
  ARBlePrairieType,
  ARVerseApportMoAutomne,
  ARVerseApportsMinerauxFractionnement,
} from './agrorendement-ble-lists.model';
import {
  ARConsoleFormatType,
  ARConsoleModulationType,
  ARConsoleType,
  ARConsoleVersion,
  ARFertilizerType,
} from './agrorendement-common-lists.model';
import { Campaign } from './campaign.model';
import { Parcel } from './parcel.model';

export class AROrgeCampaign extends Campaign {
  configuration: AROrgeCampaignConfiguration;
}

export class AROrgeCampaignConfiguration {
  id: number;

  startingOn: string | Date;
  orderT1EndingOn: string | Date;
  dataT1EndingOn: string | Date;
  orderT2EndingOn: string | Date;
  dataT2EndingOn: string | Date;
  dataT3StartingOn: string | Date;
  orderT3EndingOn: string | Date;
  dataT3EndingOn: string | Date;

  createdAt: string | Date;
  updatedAt: string | Date;

  campaign: AROrgeCampaign;
}

export class AROrgeOrder {
  id: number;
  campaign: AROrgeCampaign;
  orderItems: AROrgeOrderItem[];

  createdAt: string | Date;
  updatedAt: string | Date;
}

export class AROrgeOrderItem {
  id: number = null;

  t1Completed: boolean = null;
  t2Completed: boolean = null;
  t3Completed: boolean = null;
  agrofertCompleted: boolean = null;
  verseCompleted: boolean = null;

  hasT1: boolean = null;
  hasT2: boolean = null;
  hasT3: boolean = null;
  hasZonage: boolean = null;

  isT3Pilotage: boolean = null;

  objective: number = null;

  needsAgrofert: boolean = false;
  needsVerse: boolean = false;
  userProvidedAzote: number = null;

  t1AzoteToSpread: number = null;
  t1FertilizerType: ARFertilizerType = null;
  t1FertilizerConcentration: number = null;

  t1ConsoleModulationType: ARConsoleModulationType = null;
  t1ConsoleType: ARConsoleType = null;
  t1ConsoleVersion: ARConsoleVersion = null;
  t1OtherConsoleVersion: string = null;
  t1ConsoleFormatType: ARConsoleFormatType = null;

  t2AzoteToSpread: number = null;
  t2FertilizerType: ARFertilizerType = null;
  t2FertilizerConcentration: number = null;

  t2ConsoleModulationType: ARConsoleModulationType = null;
  t2ConsoleType: ARConsoleType = null;
  t2ConsoleVersion: ARConsoleVersion = null;
  t2OtherConsoleVersion: string = null;
  t2ConsoleFormatType: ARConsoleFormatType = null;

  t3AzoteToSpread: number = null;
  t3FertilizerType: ARFertilizerType = null;
  t3FertilizerConcentration: number = null;

  t3ConsoleModulationType: ARConsoleModulationType = null;
  t3ConsoleType: ARConsoleType = null;
  t3ConsoleVersion: ARConsoleVersion = null;
  t3OtherConsoleVersion: string = null;
  t3ConsoleFormatType: ARConsoleFormatType = null;

  etatVegetatifSh: ARBleEtatVegetatifSh = null;

  hasReliquatSh: boolean = null;
  reliquatSh: number = null;

  firstAzoteProductType: ARBleAzoteProductType = null;
  firstAzotePeriod: ARBleAzotePeriod = null;
  firstAzoteConcentration: number = null;
  firstAzoteDensity: number = null;

  secondAzoteProductType: ARBleAzoteProductType = null;
  secondAzotePeriod: ARBleAzotePeriod = null;
  secondAzoteConcentration: number = null;
  secondAzoteDensity: number = null;

  // verse
  pastAzoteFrequency: ARBleAzoteFrequency = null;
  verseApportMoAutomne: ARVerseApportMoAutomne = null;
  verseApportsMinerauxFractionnement: ARVerseApportsMinerauxFractionnement = null;

  // FIXME suppr champs agrofert
  pastAzoteProductType: ARBleAzoteProductType = null;

  hasPastAzotePreviousCulture: boolean = null;
  pastAzotePreviousCultureProductType: ARBleAzoteProductType = null;
  pastAzotePreviousCultureConcentration: number = null;
  pastAzotePreviousCultureDensity: number = null;

  pastResiduType: ARBlePastResiduType = null;

  hasPrairie: boolean = null;
  prairieAge: ARBlePrairieAge = null;
  prairieDestructionPeriod: ARBlePrairieDestructionPeriod = null;
  prairiePostDestructionRank: ARBlePrairiePostDestructionRank = null;
  prairieExploitationMode: ARBlePrairieExploitationMode = null;
  prairieType: ARBlePrairieType = null;

  hasCi: boolean = null;
  ciType: ARBleCIType = null;
  ciDevelopment: ARBleCIDevelopment = null;
  ciDestructionPeriod: ARBleCIDestructionPeriod = null;
  isCiEvery2Years: boolean = null;

  order: AROrgeOrder = null;
  parcel: AROrgeParcel = null;

  createdAt: string | Date = null;
  updatedAt: string | Date = null;

  //dates planning
  t1_date_livraison: Date = null;
  t2_date_livraison: Date = null;
  t3_date_livraison: Date = null;

  suspendedT1: boolean = false;
  suspendedT2: boolean = false;
  suspendedT3: boolean = false;

  defaultWeekT1: Date = null;
  defaultWeekT2: Date = null;
  defaultWeekT3: Date = null;
}

export class AROrgeParcel extends Parcel {
  orderItem: AROrgeOrderItem;
}
